'use strict';

var CustomerListCtrl = function(
  $state,
  customers,
  CustomerDA,
  gettextCatalog,
  uiGridConstants,
  MobileDetectService,
) {
  var self = this;
  this.customers = customers;
  this._CustomerDA = CustomerDA;
  this._state = $state;
  this.model = {
    data: customers,
    enableSorting: true,
    enableFiltering: true,
    enableRowSelection: true,
    enableRowHeaderSelection: false,
    columnDefs: [
      {
        displayName: gettextCatalog.getString('Firstname'),
        field: 'firstname',
        enableColumnMenu: false,
      },
      {
        displayName: gettextCatalog.getString('Lastname'),
        field: 'lastname',
        enableColumnMenu: false,
        sort: {
          direction: uiGridConstants.ASC,
          priority: 0,
        },
      },
    ],
    onRegisterApi: function(gridApi) {
      self.gridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged(null, function(row) {
        self.openCustomer(row.entity._id);
      });
    },
  };

  if (!MobileDetectService.isMobile) {
    this.model.columnDefs.push({
      displayName: gettextCatalog.getString('Telephone'),
      field: 'telephone',
      enableColumnMenu: false,
      enableSorting: false,
    });
  }
};

CustomerListCtrl.prototype.openCustomer = function(customerId) {
  var filteredRows = this.gridApi.core.getVisibleRows(this.gridApi.grid);
  var filteredCustomers = _.map(filteredRows, function(row) {
    return row.entity._id;
  });
  this._CustomerDA.setFiltered(filteredCustomers);
  this._state.go('private.main.customerProfile', { customerId: customerId });
};

module.exports = CustomerListCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/customer/CustomerListCtrl.js